module.exports = __webpack_public_path__ + "static/media/ITBO06.bed36472.jpg";